/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import ExtraServices from "reusables/sections/ExtraServices";

function Residential_Section5() {
  return (
    <Container>
      {/* <Grid
        container
        item
        display={"flex"}
        flexDirection={"column"}
        // alignItems="center"
        // bgcolor={"pink"}
        width={"100%"}
      >
        <Grid item>
          <SubTitleContents
            title="Extra Optional Services"
            contents="While our regular cleaning services are thorough, there are some specialized tasks that fall outside the scope. These can be requested as add-ons for an additional fee:"
          />
        </Grid>
        <MKBox> */}
      <ExtraServices
        description="While our regular cleaning services are thorough, there are some specialized tasks that fall outside the scope. These can be requested as add-ons for an additional fee:"
        services={[
          "Deep cleaning of ovens or refrigerators",
          "Interior cleaning of cupboards, wardrobes, or drawers",
          "Upholstery or carpet cleaning",
          "Cleaning of walls or ceilings",
          "Mould removal",
          "Decluttering or organizing personal belongings",
          "Cleaning exterior spaces (e.g., patios, windows, outdoor areas)",
        ]}
      />
      {/* </MKBox>
      </Grid> */}
    </Container>
  );
}

export default Residential_Section5;

// /* eslint-disable no-unused-vars */
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
// import Divider from "@mui/material/Divider";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";

// import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// function Residential_Section5() {
//   return (
//     <Container>
//       <Grid
//         container
//         item
//         display={"flex"}
//         flexDirection={"column"}
//         alignItems="center"
//         width={"100%"}
//         mx={0}
//         px={0}
//       >
//         <Grid item>
//           <SubTitleContents
//             title="What’s NOT Included in Our Regular Residential Cleaning Services?"
//             contents="While our regular cleaning covers a wide range of tasks, certain services are not included but can be arranged separately for an additional fee. These services include:"
//           />
//         </Grid>
//         <Divider sx={{ width: "100%", my: 2, borderWidth: 2 }} />
//         <Grid
//           item
//           display={"flex"}
//           flexDirection={"row"}
//           justifyContent="space-between"
//           width={"100%"}
//           mb={2}
//         >
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Deep cleaning of ovens or refrigerators
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Interior cleaning of cupboards, wardrobes, or drawers
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Upholstery or carpet cleaning
//               </MKTypography>
//             </MKBox>
//           </Grid>
//         </Grid>
//         <Grid
//           item
//           display={"flex"}
//           flexDirection={"row"}
//           justifyContent="space-between"
//           width={"100%"}
//           mb={2}
//         >
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Cleaning of walls or ceilings
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Mould removal
//               </MKTypography>
//             </MKBox>
//           </Grid>

//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Decluttering or organizing personal belongings
//               </MKTypography>
//             </MKBox>
//           </Grid>
//         </Grid>
//         <Grid
//           item
//           display={"flex"}
//           flexDirection={"row"}
//           justifyContent="space-between"
//           width={"100%"}
//           mb={2}
//         >
//           <Grid item xs={12} md={4} display={"flex"} flexDirection={"row"} pr={3}>
//             <MKBox
//               // bgColor="primary"
//               //   color="primary"
//               display="flex"
//               //   alignItems="center"
//               mr={1}
//             >
//               <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                 add
//               </Icon>
//             </MKBox>
//             <MKBox display="flex">
//               <MKTypography variant="body2" color="text" sx={{ textAlign: "justify" }}>
//                 Cleaning exterior spaces
//                 <br />
//                 (e.g., patios, windows, outdoor areas)
//               </MKTypography>
//             </MKBox>
//           </Grid>
//         </Grid>
//         <Divider sx={{ width: "100%", my: 2, borderWidth: 2 }} />
//       </Grid>
//     </Container>
//   );
// }

// export default Residential_Section5;
